import * as React from 'react';
import * as ReactDOM from 'react-dom';
import PolicyTipsOverrideDialog from '../components/PolicyTipsOverrideDialog';
import PolicyTipsViewState from '../store/schema/PolicyTipsViewState';

const POLICY_TIPS_OVERRIDE_DIALOG_ID = 'PolicyTipsDialog';

export default function showPolicyTipsOverrideDialog(viewState: PolicyTipsViewState) {
    // Only allow one dialog to exist at once
    const existingPolicyTipsDialogDiv = document.getElementById(POLICY_TIPS_OVERRIDE_DIALOG_ID);
    if (existingPolicyTipsDialogDiv == null) {
        const policyTipsDialogDiv = document.createElement('div');
        policyTipsDialogDiv.id = POLICY_TIPS_OVERRIDE_DIALOG_ID;
        document.body.appendChild(policyTipsDialogDiv);
        ReactDOM.render(
            <PolicyTipsOverrideDialog
                onClose={() => {
                    ReactDOM.unmountComponentAtNode(policyTipsDialogDiv);
                    document.body.removeChild(policyTipsDialogDiv);
                }}
                viewState={viewState}
            />,
            policyTipsDialogDiv
        );
    }
}
